"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var ShapedSelect = (0, _styledComponents["default"])(_Select["default"]).withConfig({
  displayName: "ShapedSelect",
  componentId: "sc-1k7tnb3-0"
})(["& > select{background-color:", ";border:1px solid rgba(0,0,0,0.24);border-radius:10000px;padding:12px 42px 12px 32px;transition:0.18s;}& > select:hover{border:1px solid ", ";background-color:", ";}& > select:focus{border:1px solid ", ";background-color:", ";}& > label{display:block;top:0px;left:30px;border:2px solid white;padding:0 4px;line-height:5%;overflow:visible;}& > div{padding-left:16px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.light[0];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.dark[1];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.light[0];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary[0];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.light[0];
});
var _default = ShapedSelect;
exports["default"] = _default;